import PortalIdParser from 'PortalIdParser';
import Raven from 'raven-js';
import { stringify } from 'hub-http/helpers/params';
const portalId = PortalIdParser.get();
const Links = {
  AI_FORECAST_KB: 'https://knowledge.hubspot.com/forecast/improve-forecasting-with-ai-projections',
  CURRENCY_SETTINGS: `/settings/${portalId}/account-defaults/multicurrency`,
  GOALS: `/goals/${portalId}/overview`,
  GOALS_CREATION: `/goals/${portalId}/create/1`,
  SALES_REPORTS: `/reports-list/${portalId}/templates/sales/manualForecastTotal`,
  SALES_REPORTS_WEIGHTED: `/reports-list/${portalId}/templates/sales/manualForecast`,
  SALES_REPORTS_WEIGHTED_PIPELINE: `/reports-list/${portalId}/templates/sales/weightedPipelineForecast`,
  SETTINGS: `/settings/${portalId}/sales/forecasting`,
  SETTINGS_SETUP_WITH_MODAL: `/settings/${portalId}/sales/forecasting/setup?showEditColumnsModal=true`,
  SETTINGS_MANAGE: `/settings/${portalId}/sales/forecasting/manage`,
  TEAM_SETTINGS: `/settings/${portalId}/users/teams`,
  USER_SETTINGS: `/settings/${portalId}/users`,
  USE_THE_FORECAST_TOOL_KB: 'https://knowledge.hubspot.com/forecast/use-the-forecast-tool',
  SUBMIT_A_FORECAST: 'https://knowledge.hubspot.com/forecast/use-the-forecast-tool#submit-a-forecast',
  SET_UP_FORECAST_TOOL_KB: 'https://knowledge.hubspot.com/forecast/set-up-the-forecast-tool',
  FORECAST_CATEGORIES_KB: 'https://knowledge.hubspot.com/forecast/set-up-the-forecast-tool#set-up-your-pipeline-s-forecast-categories',
  PAID_SALES_SEATS: `/settings/${portalId}/users/paid-users`,
  CONDITIONAL_PROPERTIES_LOGIC_FORECAST_CATEGORIES: `/property-settings/${portalId}/properties/conditional?type=0-3&controlling=hs_manual_forecast_category`
};
export const goalsForTeamHref = (teamId, timePeriodForLink) => {
  const endDate = `&endDate=${timePeriodForLink.startDate}%00${timePeriodForLink.endDate}`;
  return `${Links.GOALS}?viewBy=teams&teams=${teamId}&status=in_progress%00exceeded%00achieved%00missed%00pending${stringify(endDate)}`;
};

// Assumes isSuperAdmin === true
export const computeLinkToEditDefaultColumns = (isFmoEnabled, forecastTypeId) => {
  if (!isFmoEnabled) {
    return Links.SETTINGS_SETUP_WITH_MODAL;
  }

  // This state should not be possible, but if somehow is, we should log it
  if (forecastTypeId === undefined) {
    Raven.captureMessage('FMO is enabled, but forecastTypeId is undefined');
    return Links.SETTINGS_SETUP_WITH_MODAL;
  }
  return `${Links.SETTINGS_MANAGE}?showEditColumnsModal=${forecastTypeId}`;
};
export default Links;